import React from "react";

interface NavigationProps {
  onNext: () => void;
  onPrevious?: () => void;
  nextLabel?: string;
  previousLabel?: string;
  showPrevious?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({
  onNext,
  onPrevious,
  nextLabel = "Continue",
  previousLabel = "Back",
  showPrevious = true,
}) => {
  return (
    <div className="flex justify-center gap-4 items-center pt-6">
      {showPrevious && onPrevious && (
        <button
          onClick={onPrevious}
          className="px-6 py-3 rounded-full border border-heartRed text-heartRed dark:border-softRose dark:text-softRose hover:bg-heartRed/10 dark:hover:bg-softRose/10 transition-all duration-300 active:scale-95 font-light text-sm tracking-widest uppercase"
        >
          ← {previousLabel}
        </button>
      )}
      <button
        onClick={onNext}
        className="px-8 py-3 rounded-full bg-heartRed text-white hover:bg-opacity-90 dark:bg-softRose dark:hover:bg-opacity-80 transition-all duration-300 active:scale-95 shadow-md hover:shadow-lg font-light text-sm tracking-widest uppercase"
      >
        {nextLabel} →
      </button>
    </div>
  );
};
